import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function removePrompt(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.PROMPT_REMOVE,
    (organisationId, promptId) => {
      return requestor
        .delete(
          `${basePath}/organisation/${organisationId}/prompt/${promptId}`,
          {
            withCredentials: true,
          },
        )
        .then(response => response.data)
        .catch(err => err.data);
    },
  );
  return action;
}
